import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
};

export type ActNowType = {
  __typename?: 'ActNowType';
  customerBusiness: Scalars['Float'];
  customerRequirements: Scalars['Float'];
  financialMetrics: Scalars['Float'];
  forecastedSpending: Scalars['Float'];
  reasonToAct: Scalars['Float'];
};

export type ActionItemsType = {
  __typename?: 'ActionItemsType';
  action: Scalars['String'];
  category: Scalars['String'];
  id: Scalars['ID'];
  outcome?: Maybe<Outcome>;
  pillar: Scalars['String'];
  source: Scalars['String'];
};

export type BuildingBlocksType = {
  __typename?: 'BuildingBlocksType';
  costOfSale: Scalars['Float'];
  formalDecisionCriteria: Scalars['Float'];
  relationshipEcosystem: Scalars['Float'];
  solutionFit: Scalars['Float'];
  valueLevers: Scalars['Float'];
};

export type CollaborationType = {
  __typename?: 'CollaborationType';
  culture: Scalars['Float'];
  externalInfluences: Scalars['Float'];
  politicalLeverage: Scalars['Float'];
  sponsorship: Scalars['Float'];
  trustAndCredibility: Scalars['Float'];
};

export type CompetitorAnalysisType = {
  __typename?: 'CompetitorAnalysisType';
  actionItems: Array<ActionItemsType>;
  id: Scalars['ID'];
  incumbent?: Maybe<CompetitorsType>;
  otherCompetitors: CompetitorsType;
};

export type CompetitorsType = {
  __typename?: 'CompetitorsType';
  answers: ScoresType;
  scores: ScoresType;
};

/** Complete an action item */
export type CompleteActionItemInput = {
  action_item_id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  outcome: Outcome;
};

/** Customer input. */
export type CustomerInput = {
  name: Scalars['String'];
};

export type CustomerType = {
  __typename?: 'CustomerType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DesirabilityType = {
  __typename?: 'DesirabilityType';
  longTermRevenue: Scalars['Float'];
  longTermValue: Scalars['Float'];
  profitability: Scalars['Float'];
  risk: Scalars['Float'];
  shortTermRevenue: Scalars['Float'];
};

export type EventFilterInput = {
  parentId?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Source>;
};

export type EventType = {
  __typename?: 'EventType';
  createdAt: Scalars['DateTime'];
  eventType: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variables?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  completeActionItem: ActionItemsType;
  createOpportunity: OpportunityType;
  createUsers: Array<UserType>;
  updateOpportunity: OpportunityType;
};


export type MutationCompleteActionItemArgs = {
  data: CompleteActionItemInput;
};


export type MutationCreateOpportunityArgs = {
  data: OpportunityInput;
};


export type MutationCreateUsersArgs = {
  data: Array<UserInput>;
};


export type MutationUpdateOpportunityArgs = {
  data: OpportunityInput;
  id: Scalars['String'];
};

export type OpportunityFilter = {
  atRisk?: InputMaybe<Scalars['Boolean']>;
  inactive?: InputMaybe<Scalars['Boolean']>;
  open?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** Opportunity information. */
export type OpportunityInput = {
  closingDate: Scalars['DateTime'];
  currencyCode: Scalars['String'];
  customer: CustomerInput;
  description: Scalars['String'];
  name: Scalars['String'];
  state: Scalars['String'];
  value: Scalars['Decimal'];
};

export type OpportunityType = {
  __typename?: 'OpportunityType';
  closingDate: Scalars['DateTime'];
  competitorAnalysis?: Maybe<CompetitorAnalysisType>;
  createdAt: Scalars['DateTime'];
  currencyCode: Scalars['String'];
  customer: CustomerType;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  qualification?: Maybe<QualificationType>;
  relationshipMap?: Maybe<RelationshipMapType>;
  state: Scalars['String'];
  statuses: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserType;
  value: Scalars['Decimal'];
};

/** The outcome of an action */
export enum Outcome {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type QualificationType = {
  __typename?: 'QualificationType';
  actionItems: Array<ActionItemsType>;
  answers: ScoresType;
  id: Scalars['ID'];
  scores: ScoresType;
};

export type Query = {
  __typename?: 'Query';
  events: Array<EventType>;
  opportunities: Array<OpportunityType>;
  opportunity?: Maybe<OpportunityType>;
  user?: Maybe<UserType>;
  users: Array<UserType>;
};


export type QueryEventsArgs = {
  eventFilter?: InputMaybe<EventFilterInput>;
};


export type QueryOpportunitiesArgs = {
  opportunityFilter?: InputMaybe<OpportunityFilter>;
};


export type QueryOpportunityArgs = {
  opportunityId: Scalars['ID'];
};


export type QueryUserArgs = {
  userId: Scalars['Int'];
};


export type QueryUsersArgs = {
  includePending?: InputMaybe<Scalars['Boolean']>;
};

export type RelationshipMapType = {
  __typename?: 'RelationshipMapType';
  data: Scalars['String'];
  id: Scalars['ID'];
};

export type ScoresType = {
  __typename?: 'ScoresType';
  actNow: ActNowType;
  buildingBlocks: BuildingBlocksType;
  collaboration: CollaborationType;
  desirability: DesirabilityType;
};

/** The source of the event */
export enum Source {
  AccountPlan = 'ACCOUNT_PLAN',
  Opportunity = 'OPPORTUNITY',
  OpportunityQualification = 'OPPORTUNITY_QUALIFICATION'
}

/** User input. */
export type UserInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
};

export type UserType = {
  __typename?: 'UserType';
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  role: Scalars['String'];
};

export type CompleteActionItemMutationVariables = Exact<{
  actionItemInput: CompleteActionItemInput;
}>;


export type CompleteActionItemMutation = { __typename?: 'Mutation', completeActionItem: { __typename?: 'ActionItemsType', outcome?: Outcome | null } };

export type CreateOpportunityMutationVariables = Exact<{
  opportunityInput: OpportunityInput;
}>;


export type CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity: { __typename?: 'OpportunityType', id: string } };

export type GetEventsQueryVariables = Exact<{
  eventFilter?: InputMaybe<EventFilterInput>;
}>;


export type GetEventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'EventType', id: string, source: string, eventType: string, variables?: string | null, note?: string | null, createdAt: any, updatedAt: any }> };

export type GetOpportunitiesQueryVariables = Exact<{
  opportunityFilter?: InputMaybe<OpportunityFilter>;
}>;


export type GetOpportunitiesQuery = { __typename?: 'Query', opportunities: Array<{ __typename?: 'OpportunityType', id: string, name: string, description: string, value: any, currencyCode: string, state: string, statuses: Array<string>, closingDate: any, createdAt: any, updatedAt: any, customer: { __typename?: 'CustomerType', id: string, name: string }, user: { __typename?: 'UserType', id: string, name?: string | null } }> };

export type GetOpportunityQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
}>;


export type GetOpportunityQuery = { __typename?: 'Query', opportunity?: { __typename?: 'OpportunityType', id: string, name: string, description: string, value: any, currencyCode: string, state: string, statuses: Array<string>, closingDate: any, createdAt: any, updatedAt: any, customer: { __typename?: 'CustomerType', id: string, name: string }, user: { __typename?: 'UserType', id: string, name?: string | null }, qualification?: { __typename?: 'QualificationType', scores: { __typename?: 'ScoresType', actNow: { __typename?: 'ActNowType', reasonToAct: number, customerRequirements: number, forecastedSpending: number, customerBusiness: number, financialMetrics: number }, buildingBlocks: { __typename?: 'BuildingBlocksType', relationshipEcosystem: number, formalDecisionCriteria: number, solutionFit: number, costOfSale: number, valueLevers: number }, collaboration: { __typename?: 'CollaborationType', trustAndCredibility: number, externalInfluences: number, sponsorship: number, politicalLeverage: number, culture: number }, desirability: { __typename?: 'DesirabilityType', risk: number, profitability: number, longTermValue: number, longTermRevenue: number, shortTermRevenue: number } }, actionItems: Array<{ __typename?: 'ActionItemsType', id: string, source: string, pillar: string, category: string, action: string, outcome?: Outcome | null }> } | null, competitorAnalysis?: { __typename?: 'CompetitorAnalysisType', incumbent?: { __typename?: 'CompetitorsType', scores: { __typename?: 'ScoresType', actNow: { __typename?: 'ActNowType', reasonToAct: number, customerRequirements: number, forecastedSpending: number, customerBusiness: number, financialMetrics: number }, buildingBlocks: { __typename?: 'BuildingBlocksType', relationshipEcosystem: number, formalDecisionCriteria: number, solutionFit: number, costOfSale: number, valueLevers: number }, collaboration: { __typename?: 'CollaborationType', trustAndCredibility: number, externalInfluences: number, sponsorship: number, politicalLeverage: number, culture: number }, desirability: { __typename?: 'DesirabilityType', risk: number, profitability: number, longTermValue: number, longTermRevenue: number, shortTermRevenue: number } } } | null, otherCompetitors: { __typename?: 'CompetitorsType', scores: { __typename?: 'ScoresType', actNow: { __typename?: 'ActNowType', reasonToAct: number, customerRequirements: number, forecastedSpending: number, customerBusiness: number, financialMetrics: number }, buildingBlocks: { __typename?: 'BuildingBlocksType', relationshipEcosystem: number, formalDecisionCriteria: number, solutionFit: number, costOfSale: number, valueLevers: number }, collaboration: { __typename?: 'CollaborationType', trustAndCredibility: number, externalInfluences: number, sponsorship: number, politicalLeverage: number, culture: number }, desirability: { __typename?: 'DesirabilityType', risk: number, profitability: number, longTermValue: number, longTermRevenue: number, shortTermRevenue: number } } }, actionItems: Array<{ __typename?: 'ActionItemsType', id: string, source: string, pillar: string, category: string, action: string, outcome?: Outcome | null }> } | null, relationshipMap?: { __typename?: 'RelationshipMapType', data: string } | null } | null };

export type UpdateOpportunityMutationVariables = Exact<{
  id: Scalars['String'];
  opportunityInput: OpportunityInput;
}>;


export type UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'OpportunityType', id: string } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserType', id: string, name?: string | null, email: string, role: string, emailVerified?: any | null }> };

export type CreateUsersMutationVariables = Exact<{
  userInputs: Array<UserInput> | UserInput;
}>;


export type CreateUsersMutation = { __typename?: 'Mutation', createUsers: Array<{ __typename?: 'UserType', id: string, name?: string | null, email: string, role: string, emailVerified?: any | null }> };


export const CompleteActionItemDocument = gql`
    mutation completeActionItem($actionItemInput: CompleteActionItemInput!) {
  completeActionItem(data: $actionItemInput) {
    outcome
  }
}
    `;
export const CreateOpportunityDocument = gql`
    mutation createOpportunity($opportunityInput: OpportunityInput!) {
  createOpportunity(data: $opportunityInput) {
    id
  }
}
    `;
export const GetEventsDocument = gql`
    query getEvents($eventFilter: EventFilterInput) {
  events(eventFilter: $eventFilter) {
    id
    source
    eventType
    variables
    note
    createdAt
    updatedAt
  }
}
    `;
export const GetOpportunitiesDocument = gql`
    query getOpportunities($opportunityFilter: OpportunityFilter) {
  opportunities(opportunityFilter: $opportunityFilter) {
    id
    name
    description
    value
    currencyCode
    state
    statuses
    closingDate
    createdAt
    updatedAt
    customer {
      id
      name
    }
    user {
      id
      name
    }
  }
}
    `;
export const GetOpportunityDocument = gql`
    query getOpportunity($opportunityId: ID!) {
  opportunity(opportunityId: $opportunityId) {
    id
    name
    description
    value
    currencyCode
    state
    statuses
    closingDate
    createdAt
    updatedAt
    customer {
      id
      name
    }
    user {
      id
      name
    }
    qualification {
      scores {
        actNow {
          reasonToAct
          customerRequirements
          forecastedSpending
          customerBusiness
          financialMetrics
        }
        buildingBlocks {
          relationshipEcosystem
          formalDecisionCriteria
          solutionFit
          costOfSale
          valueLevers
        }
        collaboration {
          trustAndCredibility
          externalInfluences
          sponsorship
          politicalLeverage
          culture
        }
        desirability {
          risk
          profitability
          longTermValue
          longTermRevenue
          shortTermRevenue
        }
      }
      actionItems {
        id
        source
        pillar
        category
        action
        outcome
      }
    }
    competitorAnalysis {
      incumbent {
        scores {
          actNow {
            reasonToAct
            customerRequirements
            forecastedSpending
            customerBusiness
            financialMetrics
          }
          buildingBlocks {
            relationshipEcosystem
            formalDecisionCriteria
            solutionFit
            costOfSale
            valueLevers
          }
          collaboration {
            trustAndCredibility
            externalInfluences
            sponsorship
            politicalLeverage
            culture
          }
          desirability {
            risk
            profitability
            longTermValue
            longTermRevenue
            shortTermRevenue
          }
        }
      }
      otherCompetitors {
        scores {
          actNow {
            reasonToAct
            customerRequirements
            forecastedSpending
            customerBusiness
            financialMetrics
          }
          buildingBlocks {
            relationshipEcosystem
            formalDecisionCriteria
            solutionFit
            costOfSale
            valueLevers
          }
          collaboration {
            trustAndCredibility
            externalInfluences
            sponsorship
            politicalLeverage
            culture
          }
          desirability {
            risk
            profitability
            longTermValue
            longTermRevenue
            shortTermRevenue
          }
        }
      }
      actionItems {
        id
        source
        pillar
        category
        action
        outcome
      }
    }
    relationshipMap {
      data
    }
  }
}
    `;
export const UpdateOpportunityDocument = gql`
    mutation updateOpportunity($id: String!, $opportunityInput: OpportunityInput!) {
  updateOpportunity(id: $id, data: $opportunityInput) {
    id
  }
}
    `;
export const GetUsersDocument = gql`
    query getUsers {
  users {
    id
    name
    email
    role
    emailVerified
  }
}
    `;
export const CreateUsersDocument = gql`
    mutation createUsers($userInputs: [UserInput!]!) {
  createUsers(data: $userInputs) {
    id
    name
    email
    role
    emailVerified
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    completeActionItem(variables: CompleteActionItemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CompleteActionItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteActionItemMutation>(CompleteActionItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeActionItem', 'mutation');
    },
    createOpportunity(variables: CreateOpportunityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOpportunityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOpportunityMutation>(CreateOpportunityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOpportunity', 'mutation');
    },
    getEvents(variables?: GetEventsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEventsQuery>(GetEventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEvents', 'query');
    },
    getOpportunities(variables?: GetOpportunitiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOpportunitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOpportunitiesQuery>(GetOpportunitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOpportunities', 'query');
    },
    getOpportunity(variables: GetOpportunityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOpportunityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOpportunityQuery>(GetOpportunityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOpportunity', 'query');
    },
    updateOpportunity(variables: UpdateOpportunityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOpportunityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOpportunityMutation>(UpdateOpportunityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOpportunity', 'mutation');
    },
    getUsers(variables?: GetUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersQuery>(GetUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUsers', 'query');
    },
    createUsers(variables: CreateUsersMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateUsersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUsersMutation>(CreateUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUsers', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;